'use client';

import React, { useState } from 'react';
import { ChevronDown, LogOut, Settings, User, Shield } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
import avatarPhoto from "../../assets/avatar.png"
import { useNavigate } from 'react-router-dom';
import { usePageSave } from '../../contexts/PageSaveContext';
const ProfileDropdown = ({ data }) => {
  const { isPageSaved } = usePageSave()
  const [isOpen, setIsOpen] = useState(false);
  const navigate = useNavigate()
  const panNo = localStorage.getItem('PAN_NO')
  return (
    <div className="w-full max-w-md px-3 py-1 relative">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="w-full group"
        aria-expanded={isOpen}
        aria-haspopup="true"
      >
        <div className="flex items-center justify-between w-full p-1 bg-white rounded-xl shadow-sm hover:shadow-md transition-shadow">
          <div className="flex items-center gap-3">
            <div className="w-7 h-7 rounded-full overflow-hidden">
              <img
                src={avatarPhoto}
                alt="Profile avatar"
                className="w-full h-full object-cover"
              />
            </div>
            <div className="flex flex-col items-start">
              <span className={`font-medium text-[12px] ${isPageSaved('profile') ? 'text-gray-900' : 'text-red-500'}`}>
                {isPageSaved('profile') ? (data?.assessee?.firstName + " " + data?.assessee?.surNameOrOrgName) : "?"}
              </span>
              <span className="text-cyan-500 text-sm text-[11px]">{(panNo || "").toUpperCase()}</span>
            </div>
          </div>
          &nbsp; &nbsp;
          <motion.div
            animate={{ rotate: isOpen ? 180 : 0 }}
            transition={{ duration: 0.2 }}
          >
            <ChevronDown className="w-5 h-5 text-gray-400 group-hover:text-gray-600 transition-colors" />
          </motion.div>
        </div>
      </button>

      <AnimatePresence>
        {isOpen && (
          <motion.div
            initial={{ opacity: 0, y: -10 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -10 }}
            transition={{ duration: 0.2 }}
            className="absolute w-full mt-2 py-2 bg-white rounded-xl shadow-lg z-50"
          >
            <div className="px-4 py-3 border-b border-gray-100">
              <p className="text-sm text-gray-500">Signed in as</p>
              <p className="text-[10px] font-medium text-gray-900">{data?.assessee?.emailAddress ? data?.assessee?.emailAddress : "example@example.com"}</p>
            </div>

            <div className="py-1">
              <button
                className="w-full px-4 py-2 text-left text-sm text-gray-700 hover:bg-gray-50 flex items-center gap-2"
                onClick={() => navigate('/dashboard/profile')}
              >
                <User className="w-4 h-4" />
                Your Profile
              </button>
              <button
                className="w-full px-4 py-2 text-left text-sm text-gray-700 hover:bg-gray-50 flex items-center gap-2"
                onClick={() => console.log('Settings clicked')}
              >
                <Settings className="w-4 h-4" />
                Settings
              </button>
              <button
                className="w-full px-4 py-2 text-left text-sm text-gray-700 hover:bg-gray-50 flex items-center gap-2"
                onClick={() => console.log('Privacy clicked')}
              >
                <Shield className="w-4 h-4" />
                Privacy & Security
              </button>
            </div>
            {/* Sign out removed */}
          </motion.div>
        )}
      </AnimatePresence>
    </div>

  );
};

export default ProfileDropdown;
